"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UncontrolledLoop = exports.Static = exports.Loop = exports.Compose = exports.Simple = exports.resolveSimpleAnimation = void 0;
const composeAnimations_1 = require("./composeAnimations");
const createAnimation_1 = require("./createAnimation");
/**
 * Create animation from ISimpleAnimation.
 *
 * @category Animation
 * @export
 * @param {ISimpleAnimation} simpleAnimation
 * @return {*}  {(TAnimationCallback | undefined)}
 */
function resolveSimpleAnimation(simpleAnimation) {
    const animation = createAnimation_1.createAnimation(simpleAnimation);
    if (animation) {
        return (propArgumentsOrCurrentTime) => {
            var _a;
            const currentTime = typeof propArgumentsOrCurrentTime === 'number'
                ? propArgumentsOrCurrentTime
                : ((_a = propArgumentsOrCurrentTime.shape.scene) === null || _a === void 0 ? void 0 : _a.currentTime) || 0;
            animation.update(currentTime);
            return animation.value;
        };
    }
}
exports.resolveSimpleAnimation = resolveSimpleAnimation;
/**
 * resolveSimpleAnimations alias
 * @export
 * @category Animation
 */
exports.Simple = resolveSimpleAnimation;
/**
 * Compose multiple animation into one.
 *
 * @category Animation
 * @export
 * @param {Array<ISimpleAnimation>} animations
 * @return {*}  {(TAnimationCallback | undefined)}
 */
function Compose(animations) {
    const composed = composeAnimations_1.composeAnimations(animations);
    if (composed) {
        return (propArgumentsOrCurrentTime) => {
            var _a;
            const currentTime = typeof propArgumentsOrCurrentTime === 'number'
                ? propArgumentsOrCurrentTime
                : ((_a = propArgumentsOrCurrentTime.shape.scene) === null || _a === void 0 ? void 0 : _a.currentTime) || 0;
            return composed(currentTime);
        };
    }
}
exports.Compose = Compose;
/**
 * Create Loop animation.
 *
 * @category Animation
 * @export
 * @param {(Omit<ISimpleAnimation, 'direction' | 'loop'>)} loopAnimation
 * @return {*}  {(TAnimationCallback | undefined)}
 */
function Loop(loopAnimation) {
    const simpleAnimation = loopAnimation;
    if (typeof simpleAnimation.interpolator === 'undefined') {
        simpleAnimation.interpolator = 'wave';
    }
    if (simpleAnimation.interpolator) {
        if (typeof simpleAnimation.interpolator === 'string') {
            if (simpleAnimation.interpolator !== 'wave') {
                simpleAnimation.direction = 'alternate';
            }
        }
        else if (typeof simpleAnimation.interpolator === 'object' && simpleAnimation.interpolator.type !== 'wave') {
            simpleAnimation.direction = 'alternate';
        }
    }
    simpleAnimation.loop = true;
    return resolveSimpleAnimation(simpleAnimation);
}
exports.Loop = Loop;
/**
 * Create an animation that repeats once
 *
 * @category Animation
 * @export
 * @param {(Omit<ISimpleAnimation, 'direction' | 'loop'>)} staticAnimation
 * @return {*}  {(TAnimationCallback | undefined)}
 */
function Static(staticAnimation) {
    const simpleAnimation = staticAnimation;
    simpleAnimation.direction = 'normal';
    simpleAnimation.loop = false;
    return resolveSimpleAnimation(simpleAnimation);
}
exports.Static = Static;
/**
 * Create an animation that repeats in a single direction
 *
 * @category Animation
 * @export
 * @param {(Omit<ISimpleAnimation, 'direction' | 'loop'>)} uncontrolledLoopAnimation
 * @return {*}
 */
function UncontrolledLoop(uncontrolledLoopAnimation) {
    const simpleAnimation = uncontrolledLoopAnimation;
    simpleAnimation.direction = 'normal';
    simpleAnimation.loop = true;
    return resolveSimpleAnimation(simpleAnimation);
}
exports.UncontrolledLoop = UncontrolledLoop;
//# sourceMappingURL=Animation.js.map